import { HighlightSubstring, Row, Thumbnail } from '@amzn/meridian';
import type { PapiSearchFieldPapiUserSuggestionFragment } from 'generated/graphql';
import type { FC } from 'react';

export type PAPISearchFieldSuggestionProps = {
  userData: PapiSearchFieldPapiUserSuggestionFragment;
  query: string;
};

export const UnknownJobTitle = 'Unknown job title';
export const PAPISearchFieldSuggestion: FC<PAPISearchFieldSuggestionProps> = ({ userData, query }) => {
  const phonetoolImageURL = `https://internal-cdn.amazon.com/badgephotos.amazon.com/?uid=${userData.login.toLowerCase()}`;
  return (
    <Row
      data-cy={`papi-suggestion-${userData.login.toLowerCase()}`}
      spacing="300"
      width="100%"
      widths={[
        'fit',
        'fill',
        'fit',
      ]}
      wrap="down"
    >
      <Thumbnail size="small" source={phonetoolImageURL} type="square" />
      <HighlightSubstring match={query}>{`${userData.firstName} ${userData.lastName} (${userData.login}@)`}</HighlightSubstring>
      <HighlightSubstring match={query}>{userData.businessTitle ? userData.businessTitle : UnknownJobTitle}</HighlightSubstring>
    </Row>
  );
};
